import { render, staticRenderFns } from "./notBind.vue?vue&type=template&id=54ad5fff&scoped=true"
import script from "./notBind.vue?vue&type=script&lang=js"
export * from "./notBind.vue?vue&type=script&lang=js"
import style0 from "./notBind.vue?vue&type=style&index=0&id=54ad5fff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad5fff",
  null
  
)

export default component.exports